/**
 * ContentSetsCtrl controller
 */

// controller mixins
import { SET_PRICING_PAYMENT_METHOD_TYPES_LABELS, SHOWSET_TYPE_LABELS } from '../../app/core/constants'
import { isTvDip } from '../../app/helpers/fn'

ContentSetsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * ContentSetsCtrl controller
 *
 * @class ContentSetsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:ContentSetsCtrl
 */
/* @ngInject */
export default function ContentSetsCtrl ($scope, $uibModal, $location, VODSet, ShowSet, ChannelSet, LiveEventSet, MultiSet, Subscription, storageSvc, pckg, inapp, authSvc, alertSvc) {
  var vm = this
  vm.mixes = authSvc.hasAccess('viewSubscription')
    ? [['tabsCtrlMixin', 'channel_sets', 'live_event_sets', 'vod_sets', 'tv_show_sets', 'multi_sets']]
    : [['tabsCtrlMixin', 'channel_sets', 'live_event_sets', 'vod_sets', 'tv_show_sets']]

  storageSvc.remove('contentHash')

  vm.activeTab = 2

  vm.showset_type_labels = SHOWSET_TYPE_LABELS

  /**
   * Package/Network
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  vm.notTvDip = !isTvDip()

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Default Package for in-app registration
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @type {number}
   */
  vm.inappNetworkId = !inapp?.multiorgEnabled && inapp?.inAppRegistrationSettings?.enabled && inapp.inAppRegistrationSettings.network?.id

  /**
   * Default Package for Guest Mode
   *
   * @memberof mwApp/packages.controller:SubscriptionSettingsCtrl
   * @type {number}
   */
  vm.guestNetworkId = !inapp?.multiorgEnabled && inapp?.guestModeSettings?.enabled && inapp.guestModeSettings.network?.id

  // package id
  const networkId = pckg.id

  /**
   * Vod Set list
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @type {models.Coupon[]}
   */
  vm.vodSets = []

  /**
   * Assigned VODs list
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @type {models.Coupon[]}
   */
  vm.assignedVODs = []

  /**
   * Assigned VOD filter
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @type {models.Coupon[]}
   */
  vm.assignedVOD = null

  /**
   * Search content params with default values
   *
   * @memberof mwApp/reports.controller:ContentSetsCtrl
   * @type {Object}
   */
  vm.searchParams = {
    q: '',
    page: 0,
    last: false
  }

  // initialize params
  vm.searchVODAssignedParams = angular.copy(vm.searchParams)
  vm.set_pricing_payment_method_types_labels = SET_PRICING_PAYMENT_METHOD_TYPES_LABELS

  /**
   * Get Vod Sets from backend
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getVodSets = function (tableState) {
    // exit with no permission

    const params = {}
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    if (vm.assignedVOD) {
      params.vodId = vm.assignedVOD.id
    }

    VODSet.loadSmartCustom(tableState, { networkId }, params)
      .then(
        data => {
          vm.vodSets = data.content
          vm.vsIsFound = !!vm.vodSets.length
          vm.vodSetsNames = data.content.map(content => content.name)
          vm.vodSetsUsers = [] // TODO: request for users
          $scope.loading = false
        }
      )
  }

  /**
   * TV Show Set list
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @type {models.Coupon[]}
   */
  vm.showSets = []

  /**
   * Get Show Sets from backend
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getShowSets = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    ShowSet.loadSmartShowSets(tableState, { networkId, searchShow: vm.assignedTvShow })
      .then(
        data => {
          vm.showSets = data.content
          vm.tvsIsFound = !!vm.showSets.length
          vm.showSetTableState = tableState
          $scope.loading = false
        }
      )
  }

  vm.assignedTvShow = undefined

  /**
   * Filter users, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:AddUsersReportCtrl
   * @param  {Object} $select
   */
  vm.$timer = 0
  vm.openCount = 0
  vm.searchState = {}
  vm.refreshShowSetContent = function ($select = {}) {
    const search = $select.search || null

    vm.searchState.page = 0

    vm.openCount = $select.open ? vm.openCount + 1 : 0

    vm.searchState.q = search

    /*    if (vm.openCount === 1) {
          $select.search = vm.searchState.q
        } */

    if ($select.open) {
      window.clearTimeout(vm.$timer)
      vm.$timer = window.setTimeout(() => {
        ShowSet.getAssignedShows(vm.searchState, networkId)
          .then((result) => {
            vm.searchState.totalPages = result.totalPages - 1
            vm.assignedTvShows = result.content || []
          })
      }, 700)
    }
  }

  /**
   * Handler for scroll event of select list
   *
   * @param event
   */
  vm.$timerScroll = 0
  vm.showSetCallbackScroll = (event) => {
    const { page, totalPages } = vm.searchState
    if (page <= totalPages && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerScroll)
      vm.$timerScroll = window.setTimeout(() => {
        ShowSet.getAssignedShows({ ...vm.searchState, page: page + 1 }, { networkId })
          .then((result) => {
            vm.searchState.page = result.number
            vm.assignedTvShows = vm.content.concat(result.content || [])
          })
      }, 700)
    }
  }

  vm.channelSets = []

  vm.channelTableState = {}

  /**
   * Get Show Sets from backend
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getChannelSets = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    if (!authSvc.hasEnabledFlag('FEATURE_RADIO_CHANNELS_ENABLED')) {
      tableState.search.predicateObject = { ...tableState.search.predicateObject, type: 'TV' }
    }

    ChannelSet.loadSmartChannelSets(tableState, { networkId, searchChannel: vm.assignedChannel })
      .then(
        data => {
          vm.channelSets = data.content
          vm.chsIsFound = !!vm.channelSets.length
          vm.channelTableState = tableState
          $scope.loading = false
        }
      )
  }

  vm.showMultisetMessage = function () {
    if (authSvc.hasEnabledFlag('FEATURE_MULTI_SETS_ENABLED')) {
      return 'Pay attention it may affect related Multi Sets.'
    }
    return ''
  }
  /**
   * Filter users, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:AddUsersReportCtrl
   * @param  {Object} $select
   */
  vm.$timer = 0
  vm.openCount = 0
  vm.searchState = {}
  vm.assignedChannel = undefined

  vm.refreshChannelSetsContent = function ($select = {}) {
    const search = $select.search || null

    vm.searchState.page = 0

    vm.openCount = $select.open ? vm.openCount + 1 : 0

    vm.searchState.q = search

    if ($select.open) {
      window.clearTimeout(vm.$timer)
      vm.$timer = window.setTimeout(() => {
        ChannelSet.getAssignedChannels(vm.searchState, networkId)
          .then((result) => {
            vm.searchState.totalPages = result.totalPages - 1
            vm.assignedChannels = result.content || []
          })
      }, 700)
    }
  }

  /**
   * Handler for scroll event of select list
   *
   * @param event
   */
  vm.$timerScroll = 0
  vm.channelSetsCallbackScroll = (event) => {
    const { page, totalPages } = vm.searchState
    if (page <= totalPages && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerScroll)
      vm.$timerScroll = window.setTimeout(() => {
        ChannelSet.getAssignedChannels({ ...vm.searchState, page: page + 1 }, { networkId })
          .then((result) => {
            vm.searchState.page = result.number
            vm.assignedChannels = vm.content.concat(result.content || [])
          })
      }, 700)
    }
  }

  /**
   * Filter users, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:AddUsersReportCtrl
   * @param  {Object} $select
   */
  vm.$timer = 0
  vm.openCount = 0
  vm.searchState = {}
  vm.assignedLiveEvent = undefined

  vm.refreshLiveEventSetsContent = function ($select = {}) {
    const search = $select.search || null

    vm.searchState.page = 0

    vm.openCount = $select.open ? vm.openCount + 1 : 0

    vm.searchState.q = search

    if ($select.open) {
      window.clearTimeout(vm.$timer)
      vm.$timer = window.setTimeout(() => {
        LiveEventSet.getAssignedLiveEvents(vm.searchState, networkId)
          .then((result) => {
            vm.searchState.totalPages = result.totalPages - 1
            vm.assignedLiveEvents = result.content || []
          })
      }, 700)
    }
  }

  /**
   * Handler for scroll event of select list
   *
   * @param event
   */
  vm.$timerScroll = 0
  vm.liveEventSetsCallbackScroll = (event) => {
    const { page, totalPages } = vm.searchState
    if (page <= totalPages && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerScroll)
      vm.$timerScroll = window.setTimeout(() => {
        LiveEventSet.getAssignedLiveEvents({ ...vm.searchState, page: page + 1 }, { networkId })
          .then((result) => {
            vm.searchState.page = result.number
            vm.assignedLiveEvents = vm.content.concat(result.content || [])
          })
      }, 700)
    }
  }

  vm.canViewSubscriptions = authSvc.hasAccess('viewSubscription')

  /**
   * Available subscription list
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @name vm.subscriptions
   * @type {models.Subscription[]}
   */
  if (vm.canViewSubscriptions) {
    Subscription.loadAll({ networkId: pckg.id })
      .then((data) => {
        vm.subscriptions = data
          .filter(sub => sub.enabled && sub.subscriptionType === 'Subscription')
          .map(d => ({ key: d.id, value: d.name }))
      })
  }

  /**
   * Delete vod set
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @function
   * @param {models.VODSet} vs
   */
  vm.deleteVodSet = function (vs) {
    vs._delete().then(() => $scope.$broadcast('refreshTable'))
  }

  vm.liveEventSets = []

  vm.liveEventTableState = {}

  /**
   * Get Live Event Sets from backend
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getLiveEventSets = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    LiveEventSet.loadSmartLiveEventSets(tableState, { networkId, searchLiveEvent: vm.assignedLiveEvent })
      .then(
        data => {
          vm.liveEventSets = data.content
          vm.liveEventSets.forEach((set) => {
            set.networkId = networkId
          })
          vm.liveEventTableState = tableState
          $scope.loading = false
        }
      )
  }

  /**
   * Delete tv Show set
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @function
   * @param {models.ShowSet} ss
   */
  vm.deleteShowSet = function (ss) {
    ss._delete().then(() => vm.getShowSets(vm.showSetTableState))
  }

  /**
   * Delete Channel set
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @function
   * @param {models.ChannelSet} cs
   */
  vm.deleteChannelSet = function (cs) {
    const message = { header: `Delete Channel Set ${cs.name}`, text: `Are you sure you want to delete Channel Set permanently? ${vm.showMultisetMessage()}` }
    const deleteCS = () => cs._delete().then(() => vm.getChannelSets(vm.channelTableState))
    if (!cs.assignedSubscriptions.length) {
      alertSvc.confirm(message)
        .then(deleteCS)
      return
    }

    cs._checkForUsageInDiscounts()
      .then(data => {
        if (!data.canDelete) {
          alertSvc.confirm({ header: message.header, text: 'This Content set is used in Subscription(s) pricing rules. To remove it contact your administrator' }, { onlyOk: true })
          return
        }

        if (data.pricingRules.subscriptions.length) {
          const text = `This Content set is used in pricing rules of Subscription(s) ${data.pricingRules.subscriptions.map(s => s.name).join(', ')}. ` +
            'Please pay attention that if you delete this Content Set, these pricing rules will be changed or deleted. <br><br>'
          message.text = text + message.text
          if (!authSvc.hasAccess('editSubscription')) {
            alertSvc.confirm({ header: 'Note!', text: 'This Content set is used in Subscription(s) pricing rules. To remove it contact your administrator' }, { onlyOk: true })
            return
          }
        }

        alertSvc.confirm(message)
          .then(deleteCS)
      })
  }

  /**
   * Delete Live Event set
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @function
   * @param {models.LiveEventSet} les
   */
  vm.deleteLiveEventSet = function (les) {
    les._delete().then(() => vm.getLiveEventSets(vm.liveEventTableState))
  }

  vm.multiSets = []

  vm.multiTableState = {}
  /**
   * Get Multi Sets from backend
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getMultiSets = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }
    if (authSvc.hasAccess('viewSubscription')) {
      MultiSet.loadSmartMultiSets(tableState, { networkId, searchLiveEvent: vm.assignedLiveEvent })
        .then(
          data => {
            vm.multiSets = data.content
            vm.multiSets.forEach((set) => {
              set.networkId = networkId
            })
            vm.multiTableState = tableState
            $scope.loading = false
          }
        )
    }
  }

  /**
   * Delete tv multi set
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @function
   * @param {models.ShowSet} ss
   */
  vm.deleteMultiSet = function (ss) {
    ss._delete().then(() => $scope.$broadcast('refreshTable', { id: 'multiSetTable' }))
  }

  $scope.$watch('vm.assignedTvShow', () => {
    if (vm.assignedTvShow !== undefined) {
      vm.getShowSets(vm.showSetTableState)
    }
  })

  $scope.$watch('vm.assignedChannel', () => {
    if (vm.assignedChannel !== undefined) {
      vm.getChannelSets(vm.channelTableState)
    }
  })

  $scope.$watch('vm.assignedLiveEvent', () => {
    if (vm.assignedLiveEvent !== undefined) {
      vm.getLiveEventSets(vm.liveEventTableState)
    }
  })

  /**
   * On/Off
   *
   * @memberof mwApp/shows.controller:ContentSetsCtrl
   * @param {model} en - entity
   */
  vm.onOffCustom = function (en) {
    return en._onOff()
  }

  /**
   * On/Off
   *
   * @memberof mwApp/shows.controller:ContentSetsCtrl
   * @param {models.LiveEventSet} les
   */
  vm.onOffLes = function (les) {
    les._onOff()
  }

  /**
   * Handler for scroll event of Assigned select list
   *
   * @memberof mwApp/shows.controller:ContentSetsCtrl
   * @param event
   */
  vm.$timerVODAssignedScroll = 0
  vm.contentCallbackAssignedScroll = (event) => {
    const {
      page,
      last
    } = vm.searchVODAssignedParams
    if (!vm.isNew && !last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerVODAssignedScroll)
      vm.$timerVODAssignedScroll = window.setTimeout(() => {
        VODSet.getAssignedVODs(networkId, {
          ...vm.searchVODAssignedParams,
          page: page + 1
        }).then((result) => {
          const content = angular.copy(result.content)
          vm.searchVODAssignedParams.last = result.last
          vm.assignedVODs = vm.assignedVODs.concat(content)
          vm.searchVODAssignedParams.page = result.number
        })
      }, 700)
    }
  }

  /**
   * Filter vod-sets, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:ContentSetsCtrl
   * @param  {Object} $select
   */
  vm.$timer = 0
  vm.openCount = 0
  vm.refreshVODs = function ($select = {}) {
    const search = $select.search || null

    vm.searchVODAssignedParams.page = 0

    vm.openCount = $select.open ? vm.openCount + 1 : 0

    if (vm.openCount >= 1 && search) {
      vm.searchVODAssignedParams.q = search
    }

    /*
      if (vm.openCount === 1) {
        $select.search = vm.tableState.name
      } */

    if ($select.open) {
      window.clearTimeout(vm.$timer)
      vm.$timer = window.setTimeout(() => {
        VODSet.getAssignedVODs(networkId, { ...vm.searchVODAssignedParams })
          .then((result) => {
            vm.assignedVODs = result.content
            vm.searchVODAssignedParams.last = result.last
          })
      }, 700)
    }
  }

  vm.viewContentSet = function (contentSet, type) {
    $uibModal.open({
      templateUrl: 'components/packages/views/viewContentSet.html',
      controller: 'ViewContentSetCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        networkId: function () {
          return pckg.id
        },
        type: function () {
          return type
        },
        cs: function () {
          switch (type) {
            case 'tvShowSet':
              return ShowSet.load({
                networkId: pckg.id,
                id: contentSet.id
              }).then((ss) => {
                ss.networkId = pckg.id
                return ss
              })
            case 'vodSet':
              return VODSet.load({
                networkId: pckg.id,
                id: contentSet.id
              }).then((vs) => {
                vs.networkId = pckg.id
                return vs
              })
            case 'channelSet':
              return ChannelSet.load({
                networkId: pckg.id,
                id: contentSet.id
              }).then((cs) => {
                cs.networkId = pckg.id
                return cs
              })
            case 'liveEventSet':
              return LiveEventSet.load({
                networkId: pckg.id,
                id: contentSet.id
              }).then((les) => {
                les.networkId = pckg.id
                return les
              })
            case 'multiSet':
              return MultiSet.load({
                networkId: pckg.id,
                id: contentSet.id
              }).then((ms) => {
                ms.networkId = pckg.id
                return ms
              })
          }
          return {}
        },
        notTvDip: function () {
          return vm.notTvDip
        }
      }
    }).result
      .then(
        function close () {
        },
        function dismiss () {
        })
  }

  vm.setHash = function () {
    storageSvc.set('contentHash', $location.hash())
  }

  vm.selectVODFilter = function () {
    $scope.$broadcast('refreshTable', { id: 'vodSetsTable' })
  }
}
